<template>
  <div class="container containerMoca">
    <heard :title="'老年多模态多媒体语料库切分标注平台--MoCA量表'" />
    <div class="content" id="content">
      <div class="title">
       <el-button @click="goBack" style="background-color:rgba(2, 72, 167);border-color:rgba(2, 72, 167)" class="backIcon" type="primary" icon="el-icon-arrow-left" circle size="mini"></el-button>
        MoCA量表
        <el-button
          v-if="showExport && $route.query.type"
          type="primary"
          size="mini"
          class="userPotrait"
          @click="exportPdf"
          style="background-color:rgba(2, 72, 167);border-color:rgba(2, 72, 167)"
          >导出</el-button
        >
      </div>
      <div class="examTable">
        <div class="heard">
          <div>姓名</div>
          <div><el-input v-model="params.patientName" /></div>
          <div>性别</div>
          <div><el-input v-model="params.patientSex" /></div>
          <div>出生日期</div>
          <div><el-input v-model="params.patientBirthday" /></div>
          <div>教育水平</div>
          <div><el-input v-model="params.patientDegree" /></div>
          <div>检查日期</div>
          <div><el-input v-model="params.checkDate" /></div>
        </div>
        <div class="tableBody">
          <!-- 视空间与执行功能 -->
          <div class="tableItemTitle">
            <div class="left">视空间与执行功能</div>
            <div class="right">得分</div>
          </div>
          <div class="tableItemRow">
            <div class="one">
              <img src="../assets/1.jpg" alt="" />
            </div>
            <div class="two">
              <img src="../assets/2.jpg" alt="" />
              <div class="descript">复制立方体</div>
            </div>
            <div class="one">
              <div>画钟表（ 11点过10分 ）（3分）</div>
            </div>
            <div class="score">
              <el-input placeholder="" size="small" v-model="from.a[5]">
                <template slot="append">/5</template>
              </el-input>
            </div>
          </div>
          <div class="tableItemRow l-t">
            <div class="row-item l-r">
              <el-input v-model="from.a[0]" placeholder="【】" />
            </div>
            <div class="row-item l-r">
              <el-input v-model="from.a[1]" placeholder="【】" />
            </div>
            <div class="row-item l-r">
              <div style="flex-shrink: 0">轮廓</div>
              <el-input v-model="from.a[2]" placeholder="【】" />
              <div style="flex-shrink: 0; margin-left: 4px">指针</div>
              <el-input v-model="from.a[3]" placeholder="【】" />
              <div style="flex-shrink: 0; margin-left: 4px">数字</div>
              <el-input v-model="from.a[4]" placeholder="【】" />
            </div>
          </div>
          <!-- 命名 -->
          <div
            class="tableItemRow l-t l-b"
            style="padding: 8px; border-left: 0; font-weight: bold"
          >
            命名
          </div>
          <div class="tableItemRow">
            <div class="one">
              <img src="../assets/3.jpg" alt="" />
            </div>
            <div class="one">
              <img src="../assets/4.jpg" alt="" />
            </div>
            <div class="one">
              <img src="../assets/5.jpg" alt="" />
            </div>
            <div class="score">
              <el-input size="small" placeholder="" v-model="from.b[3]">
                <template slot="append">/3</template>
              </el-input>
            </div>
          </div>
          <div class="tableItemRow l-t">
            <div class="row-item l-r">
              <el-input v-model="from.b[0]" placeholder="【】" />
            </div>
            <div class="row-item l-r">
              <el-input v-model="from.b[1]" placeholder="【】" />
            </div>
            <div class="row-item l-r">
              <el-input v-model="from.b[2]" placeholder="【】" />
            </div>
          </div>
          <!-- 记忆 -->
          <div class="tableItemRow l-t" style="height: 120px">
            <div class="items name l-r">记忆</div>
            <div class="items l-r" style="width: 20%">
              读出下列词语，然后由患者重复上述过程重复2次，5分钟后回忆。
            </div>
            <div class="td">
              <div class="l-r l-b"></div>
              <div class="l-r l-b">第一次</div>
              <div class="l-r">第二次</div>
            </div>
            <div class="td">
              <div class="l-r l-b">面孔</div>
              <div class="l-r l-b">
                <el-input v-model="from.c[0]" size="small " placeholder="" />
              </div>
              <div class="l-r">
                <el-input v-model="from.c1[0]" size="small " placeholder="" />
              </div>
            </div>
            <div class="td">
              <div class="l-r l-b">天鹅绒</div>
              <div class="l-r l-b">
                <el-input v-model="from.c[1]" size="small " placeholder="" />
              </div>
              <div class="l-r">
                <el-input v-model="from.c1[1]" size="small " placeholder="" />
              </div>
            </div>
            <div class="td">
              <div class="l-r l-b">教堂</div>
              <div class="l-r l-b">
                <el-input v-model="from.c[2]" size="small " placeholder="" />
              </div>
              <div class="l-r b">
                <el-input v-model="from.c1[2]" size="small " placeholder="" />
              </div>
            </div>
            <div class="td">
              <div class="l-r l-b">菊花</div>
              <div class="l-r l-b">
                <el-input v-model="from.c[3]" size="small " placeholder="" />
              </div>
              <div class="l-r">
                <el-input v-model="from.c1[3]" size="small " placeholder="" />
              </div>
            </div>
            <div class="td">
              <div class="l-r l-b">红色</div>
              <div class="l-r l-b">
                <el-input v-model="from.c[4]" size="small " placeholder="" />
              </div>
              <div class="l-r">
                <el-input v-model="from.c1[4]" size="small " placeholder="" />
              </div>
            </div>
            <div class="score">不计分</div>
          </div>
          <!-- 注意 -->
          <div class="tableItemRow l-t" style="height: 80px">
            <div class="items name l-r">注意</div>
            <div class="td1 l-r">读出下列数字，请患者重复（每秒1个）。</div>
            <div class="td2 l-r">
              <div class="l-b">
                顺背<el-input
                  v-model="from['d1']['child'][0]"
                  size="small "
                  style="width: 80px; margin-left: 8px"
                  placeholder="【】"
                />
              </div>
              <div>
                倒背<el-input
                  v-model="from.d1['child'][1]"
                  size="small "
                  style="width: 80px; margin-left: 8px"
                  placeholder="【】"
                />
              </div>
            </div>
            <div class="td2 l-r">
              <div class="l-b fontBold">21854</div>
              <div class="fontBold">742</div>
            </div>
            <div class="score">
              <el-input
                placeholder=""
                size="small"
                v-model="from['d1']['score']"
              >
                <template slot="append">/2</template>
              </el-input>
            </div>
          </div>
          <!-- 读 -->
          <div class="tableItemRow l-t" style="height: 80px">
            <div class="td3 l-r">
              读出下列数字，每当数字出现1时，患者敲1下桌面，错误数大于或等于2不给分。
            </div>
            <div class="td3">
              <el-input
                v-model="from.d[0]"
                style="width: 180px; margin-right: 8px"
                size="small "
                placeholder="【】"
              />52139411806215194511141905112
            </div>
            <div class="score l-l">
              <el-input size="small" placeholder="" v-model="from.d[1]">
                <template slot="append">/2</template>
              </el-input>
            </div>
          </div>
          <!-- 算 -->
          <div class="tableItemRow l-t" style="height: 80px">
            <div style="display: flex; width: 90%; flex-direction: column">
              <div style="display: flex; width: 100%" class="l-b">
                <div class="td4" style="width: 30%">
                  <div class="l-r">100连续减7</div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    93
                    <el-input
                      style="width: 80px; margin-left: 8px"
                      v-model="from.e[0]"
                      size="small "
                      placeholder="【】"
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    86<el-input
                      style="width: 80px; margin-left: 8px"
                      v-model="from.e[1]"
                      size="small "
                      placeholder="【】"
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    79<el-input
                      style="width: 80px; margin-left: 8px"
                      v-model="from.e[2]"
                      size="small "
                      placeholder="【】"
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    72<el-input
                      style="width: 80px; margin-left: 8px"
                      v-model="from.e[3]"
                      size="small "
                      placeholder="【】"
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    65<el-input
                      style="width: 80px; margin-left: 8px"
                      v-model="from.e[4]"
                      size="small "
                      placeholder="【】"
                    />
                  </div>
                </div>
              </div>
              <div class="calc l-r">
                4~5个正确给3分，2~3个正确给1分，全部错误为0分。
              </div>
            </div>
            <div class="score">
              <el-input size="small" placeholder="" v-model="from.e[5]">
                <template slot="append">/3</template>
              </el-input>
            </div>
          </div>
          <!-- 语言 -->
          <div class="tableItemRow l-t countomer_append" style="height: 80px">
            <div class="items name l-r">语言</div>
            <div style="height: 80px; width: 80%">
              <div class="td5 l-b">
                <div>
                  重复：<span style="margin-left: 15px; margin-right: 5px"
                    >我只知道今天张亮是来帮过忙的人</span
                  >
                  <el-input
                    style="width: 80px"
                    v-model="from.f[0]"
                    size="small "
                    placeholder="【】"
                  />
                  <span style="margin-left: 20px; margin-right: 5px"
                    >狗在房间的时候，猫总是躲在沙发下面</span
                  >
                  <el-input
                    style="width: 80px"
                    v-model="from.f[1]"
                    size="small "
                    placeholder="【】"
                  />
                  <!-- 重复：我只知道今天张亮是来帮过忙的人。[ ]
                  狗在房间的时候，猫总是躲在沙发下面” [ ] -->
                </div>
              </div>
              <div class="td5">
                <div>
                  <span style="margin-right: 5px"
                    >流畅性：在1分钟内尽可能多地说出动物的名字</span
                  >
                  <el-input
                    style="width: 280px"
                    v-model="from.g[0]"
                    size="small "
                    placeholder="【N】"
                  />
                  (N≥11名称)
                  <!-- 流畅性：在1分钟内尽可能多地说出动物的名字。[
                  ]____________________________(N≥11名称) -->
                </div>
              </div>
            </div>
            <div class="score l-l scoreList">
              <div class="l-b">
                <el-input size="small" placeholder="" v-model="from.f[2]">
                  <template slot="append">/2</template>
                </el-input>
              </div>
              <div>
                <el-input size="small" placeholder="" v-model="from.g[1]">
                  <template slot="append">/1</template>
                </el-input>
              </div>
            </div>
          </div>
          <!-- 抽象 -->
          <div class="tableItemRow l-t" style="height: 40px">
            <div class="items name l-r">抽象</div>
            <div class="td6">
              <div>
                词语相似性：香蕉—桔子=水果
                <el-input
                  style="width: 80px; margin-left: 50px; margin-right: 5px"
                  v-model="from.h[0]"
                  placeholder="【】"
                  size="small "
                />火车—自行车<el-input
                  style="width: 80px; margin-left: 50px; margin-right: 5px"
                  v-model="from.h[1]"
                  placeholder="【】"
                  size="small "
                />手表—尺子
              </div>
            </div>
            <div class="score l-l">
              <el-input size="small" placeholder="" v-model="from.h[2]">
                <template slot="append">/2</template>
              </el-input>
            </div>
          </div>
          <!-- 延迟回忆 -->
          <div class="tableItemRow l-t countomer_append" style="height: 120px">
            <div class="items name l-r">延迟回忆</div>
            <div class="td7 l-r">
              <div class="td7Item">
                <div class="td7ItemRow flexAll l-r l-b">回忆时不能提醒</div>
                <div class="td7ItemRow flexAll l-r l-b">
                  面孔<el-input
                    placeholder="【】"
                    style="width: 80px; margin-left: 5px"
                    v-model="from.i[0]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r l-b">
                  天鹅绒<el-input
                    style="width: 80px; margin-left: 5px"
                    placeholder="【】"
                    v-model="from.i[1]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r l-b">
                  教堂<el-input
                    style="width: 80px; margin-left: 5px"
                    placeholder="【】"
                    v-model="from.i[2]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r l-b">
                  菊花<el-input
                    style="width: 80px; margin-left: 5px"
                    placeholder="【】"
                    v-model="from.i[3]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-b">
                  红色<el-input
                    style="width: 80px; margin-left: 5px"
                    placeholder="【】"
                    v-model="from.i[4]"
                    size="small "
                  />
                </div>
              </div>
              <div class="td7Item">
                <div class="td7ItemRow flexAll l-r l-b">分类提醒</div>
                <div class="td7ItemRow flexAll l-r l-b">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.j[0]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r l-b">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.j[1]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r l-b">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.j[2]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r l-b">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.j[3]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-b">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.j[4]"
                    size="small "
                  />
                </div>
              </div>
              <div class="td7Item">
                <div class="td7ItemRow flexAll l-r">多选提醒</div>
                <div class="td7ItemRow flexAll l-r">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.k[0]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.k[1]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.k[2]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll l-r">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.k[3]"
                    size="small "
                  />
                </div>
                <div class="td7ItemRow flexAll">
                  <el-input
                    style="width: 80px"
                    placeholder=""
                    v-model="from.k[4]"
                    size="small "
                  />
                </div>
              </div>
            </div>
            <div class="td7Right l-r flexAll">仅根据非提示记忆得分</div>
            <div class="score scoreList">
              <div class="l-b">
                <el-input size="small" placeholder="" v-model="from.i[5]">
                  <template slot="append">/2</template>
                </el-input>
              </div>
              <div class="l-b">
                <el-input size="small" placeholder="" v-model="from.j[5]">
                  <template slot="append">/2</template>
                </el-input>
              </div>
              <div>
                <el-input size="small" placeholder="" v-model="from.k[5]">
                  <template slot="append">/2</template>
                </el-input>
              </div>
            </div>
          </div>
          <!-- 定向 -->
          <div class="tableItemRow l-t" style="height: 40px">
            <div class="items name l-r">定向</div>
            <div style="display: flex; width: 80%; flex-direction: column">
              <div style="display: flex; width: 100%" class="l-b">
                <div class="td4">
                  <div class="l-r">
                    日期<el-input
                      style="width: 80px; margin-left: 5px"
                      placeholder="【】"
                      v-model="from.l[0]"
                      size="small "
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    月份<el-input
                      style="width: 80px; margin-left: 5px"
                      placeholder="【】"
                      v-model="from.l[1]"
                      size="small "
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    年代<el-input
                      style="width: 80px; margin-left: 5px"
                      placeholder="【】"
                      v-model="from.l[2]"
                      size="small "
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    星期几<el-input
                      style="width: 80px; margin-left: 5px"
                      placeholder="【】"
                      v-model="from.l[3]"
                      size="small "
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    地点<el-input
                      style="width: 80px; margin-left: 5px"
                      placeholder="【】"
                      v-model="from.l[4]"
                      size="small "
                    />
                  </div>
                </div>
                <div class="td4">
                  <div class="l-r">
                    城市<el-input
                      style="width: 80px; margin-left: 5px"
                      placeholder="【】"
                      v-model="from.l[5]"
                      size="small "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="score">
              <el-input size="small" placeholder="" v-model="from.l[6]">
                <template slot="append">/6</template>
              </el-input>
            </div>
          </div>
          <!-- 总分 -->
          <div
            class="tableItemRow l-t countomer_append_total"
            style="height: 40px"
          >
            <div class="items name l-r">总分</div>
            <div
              style="display: flex; width: 80%; flex-direction: column"
              class="l-r"
            >
              <div style="display: flex; width: 100%"></div>
            </div>
            <div class="score">
              <el-input size="small" disabled placeholder="" v-model="total">
                <template slot="append">/32</template>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomWrap" v-if="!type && showExport">
        <el-button type="primary" style="background-color:rgba(2, 72, 167);border-color:rgba(2, 72, 167);width: 130px" @click="submit" 
          >保存</el-button
        >
      </div>
    </div>
    <foot :show='true' ref="foot" :url="params.audioUrl" />
  </div>
</template>

<script>
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";
import user from "../components/portrait.vue";
import { addmoca, getmocaDetail, updatemoca } from "../utils/moca";
import { mapState } from "vuex";
export default {
  name: "VueMmse",
  data() {
    return {
      showExport: true,
      from: {
        // 视空间与执行功能
        a: ["", "", "", "", "", ""],
        // 命名
        b: ["", "", "", ""],
        // 记忆1
        c: ["", "", "", "", ""],
        // 记忆2
        c1: ["", "", "", "", ""],
        // 注意
        d1: {
          child: ["", ""],
          score: "",
        },
        // 读
        d: ["", ""],
        // 减法
        e: ["", "", "", "", "", ""],
        // 语言1
        f: ["", "", ""],
        // 语言2
        g: ["", ""],
        // 抽象
        h: ["", "", ""],
        //延迟回忆1
        i: ["", "", "", "", "", ""],
        //延迟回忆2
        j: ["", "", "", "", "", ""],
        //延迟回忆3
        k: ["", "", "", "", "", ""],
        // 定向
        l: ["", "", "", "", "", "", ""],
      },
      total: 0,
      breadcrumbObj:{},
      params: {
        userId: "",
        userName: "",
        userHospital: "",
        clinicalImpression: "",
        patientName: "",
        patientSex: "",
        patientBirthday: "",
        patientAge: "",
        patientDegree: "",
        patientTelephone: "",
        patientAddress: "",
        patientBedNumber: "",
        patientAdmissionNumber: "",
        primaryDiagnosis: "",
        answerInfos: "",
        totalScore: "",
        checkDate:''
      },
    };
  },
  watch: {
    from: {
      handler(newValue) {
        let total = 0;
        for (const key in newValue) {
          if (key != "c1" && key != "c") {
            if (key != "d1") {
              const arr = newValue[key];
              const rowTotal = arr[arr.length - 1];
              total += rowTotal * 1;
            } else {
              total += newValue[key]["score"] * 1;
            }
          }
        }
        this.m = total;
        this.total = total;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    editId() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
  },
  mounted() {
    if (this.editId) {
      getmocaDetail(this.editId).then((res) => {
        this.from = JSON.parse(res.data.answerInfos);
        this.params = res.data;
      });
    }
  },
  beforeRouteEnter(to,from,next){
  next(vm => {
    vm.breadcrumbObj = {name:from.meta.title,path:from.path}
  })
},
  methods: {
    goBack(){
      this.$router.push(this.breadcrumbObj.path)
    },
    exportPdf() {
      this.showExport = false;
      setTimeout(() => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          backgroundColor: "hsla(0,0%,100%,.9)",
        });
        let name = `${this.params.patientName}_moca.pdf`;
        let inpArray = Array.from(
          document.getElementsByClassName("el-input__inner")
        );
        inpArray.forEach((item) => {
          item.style.paddingTop = "4px";
        });
        this.getPdf(name, "content").then(() => {
          inpArray.forEach((item) => {
            this.showExport = true;
            item.style.paddingTop = "";
            loading.close();
          });
        });
      });
    },
    submit() {
      if( !this.editId && !this.$refs.foot.uploadMsg && this.$refs.foot.startDisabled){
          this.$message.warning('请先停止录音')
          return
        }
      this.$confirm("确认提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.params.userId = this.userInfo.userId;
          this.params.userName = this.userInfo.userName;
          this.params.totalScore = this.total;
           delete this.params.currUserLevel
          delete this.params.userLevel
          this.params.answerInfos = JSON.stringify(this.from);
          if (this.editId) {
            this.params.id = this.editId;
            delete this.params.updatedTime;
            delete this.params.updatedBy;
            delete this.params.doctorName;
            delete this.params.createdTime;
            delete this.params.createdBy;
          }else{
            this.params.audioUrl = this.$refs.foot.uploadMsg
          }
          
          try {
            this.editId
              ? await updatemoca(this.params)
              : await addmoca(this.params);
            this.$router.push({ path: "/user", query: { isMoca: true } });
            // this.$message({
            //   type: "success",
            //   message: "提交成功，可前往个人中心查看",
            // });
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {
    heard,
    foot,
    user,
  },
};
</script>
<style lang="less">
.countomer_append {
  .el-input-group__append {
    width: 54.19px;
  }
}
.countomer_append_total .el-input-group__append {
  padding: 0 16px;
}
.containerMoca .el-input-group__append {
  height: 30px;
  line-height: 30px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
<style lang="less" scoped>
.l-l {
  border-left: 1px solid black;
}
.l-r {
  border-right: 1px solid black;
}
.l-t {
  border-top: 1px solid black;
}
.l-b {
  border-bottom: 1px solid black;
}
.border {
  border: 1px solid black;
}
.fontBold {
  font-weight: bold;
}
.flexAll {
  display: flex;
  justify-content: center;
  align-items: center;
}
.container {
  width: 100%;
  height: 100vh;
  .el-input {
    margin: 0;
  }
  .content {
    box-sizing: border-box;
    overflow-y: auto;
    padding: 0 60px;
    .title {
      margin: 30px 0;
      color: black;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      position: relative;
      .backIcon{
        position: absolute;
        left: 0;
        top: 0;
      }
      .userPotrait {
        position: absolute;
        right: 0px;
        top: 0;
      }
    }
    .examTable {
      border: 1px solid black;
      margin-bottom: 55px;
      .heard {
        display: flex;
        div {
          box-sizing: border-box;
          border-right: 1px solid black;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          &:last-child {
            border: 0;
          }
        }
      }
      .tableBody {
        .tableItemTitle {
          justify-content: space-between;
          display: flex;
          border-top: 1px solid black;
          border-bottom: 1px solid black;
          font-weight: bold;
          .left {
            padding: 8px;
            padding-right: 0;
            padding-left: 0;
            width: 30%;
            box-sizing: border-box;
          }
          .right {
            border-left: 1px solid black;
            width: 10%;
            box-sizing: border-box;
            padding: 8px;
          }
        }
        .tableItemRow {
          display: flex;
          .row-item {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px;
            width: 30%;
            box-sizing: border-box;
          }
          .items {
            width: 10%;
            box-sizing: border-box;
            padding: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .name {
            font-size: 20px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .td {
            width: 10%;
            box-sizing: border-box;
            div {
              height: 40px;
              line-height: 40px;
              box-sizing: border-box;
              text-align: center;
            }
          }
          .td1 {
            width: 50%;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .td2 {
            width: 15%;
            box-sizing: border-box;
            div {
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .td3 {
          width: 45%;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px;
          // font-size: 18px;
        }
        .td4 {
          height: 40px;
          flex: 1;
          flex-direction: column;
          div {
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .td5 {
          height: 40px;
          width: 100%;
          div {
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .td6 {
          flex: 1;
          box-sizing: border-box;
        }
        .one {
          width: 30%;
          height: 300px;
          padding: 10px;
          border-right: 1px solid black;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .calc {
          height: 40px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        .scoreList {
          display: flex;
          flex-direction: column;
          div {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .td6 {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .td7 {
          width: 70%;
          box-sizing: border-box;
          .td7Item {
            display: flex;
            .td7ItemRow {
              flex: 1;
              height: 40px;
              box-sizing: border-box;
            }
          }
        }
        .td7Right {
          width: 10%;
          box-sizing: border-box;
          padding: 8px;
        }
        .two {
          box-sizing: border-box;
          width: 30%;
          height: 300px;
          padding: 10px;
          border-right: 1px solid black;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          img {
            width: 50%;
            height: 50%;
          }
          .descript {
            margin-left: 25px;
            writing-mode: tb-rl;
            font-size: 20px;
          }
        }
        .score {
          padding: 0 10px;
          width: calc(10% - 20px);
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .bottomWrap {
    width: 100%;
    margin-bottom: 80px;
    display: flex;
    justify-content: center;
  }
}
</style>
